import {
  Button,
  Grid,
  Link,
  Switch,
  Typography,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import AddTestDetail from "../components/AddTestDetail";
import { StepStatus } from "../../common/types/Stepper";
import SectionInContent from "../common/SectionInContent";
import SectionInContentItem from "../common/SectionInContentItem";
import { userStyles } from "../styles";
import AddRequestDetail from "../components/AddRequestDetail";
import DialogLarge from "../common/DialogLarge";
import AddOrderNotes from "../components/AddOrderNotes";
import RequestInfo from "../components/RequestInfo";
import SelectContentOwners from "../components/SelectContentOwners";
import { MyPATDialog, MyPATTextField } from "../../common";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import AddQuestionDetail from "../components/AddQuestionDetail";
import { ContentSubType } from "../../test-template/types/ContentSubTypeBody";
import { getContentSubType } from "../../test-template/actions/testTemplateActions";
import _ from "lodash";
import { Client, ContentRequest, Subject } from "../types/ContentRequest";
import {
  extractUserIdsFromRequest,
  generateDefaultContentRequest,
  hasTestOwnerStartedWork,
  hasWorkStartedForASubject,
  isLoggedInUserCenterHead,
  isLoggedInUserMultiCenterHead,
  prePublishRequestModifications,
  preSaveRequestModifications,
  validateBasicDetails,
  validateOrderNotes,
  validateRequestDetails,
  validateSelectContentOwners,
} from "../helpers/createContentRequest";
import { RequestContentType } from "../types/ContentRequestCreate";
import { RouteComponentProps } from "react-router-dom";
import contentRequestServices from "../services/contentRequestServices";
import ACLService from "../../acl/services/aclService";
import { setActiveTab } from "../actions/contentRequestActions";
import { Tabs } from "../types/Constants";
import { contentRequestCreateActions } from "../reducers/contentRequestCreateReducer";
import MyPATCollapseSection from "../../common/MyPATCollapseSection";
import MyPATCollapseSectionItem from "../../common/MyPATCollapseSectionItem";
import MyPATBaseSection, {
  SectionFocusedContext,
  SectionFocusedContextValue,
} from "../../common/MyPATBaseSection";
import { bindActionCreators } from "redux";
interface RouteParams {
  requestContentType: RequestContentType;
  requestId: string;
}
interface ContentRequestCreateProps
  extends WithStyles<typeof userStyles>,
    RouteComponentProps<RouteParams> {
  contentsubType: ContentSubType[];
  getContentSubType: (subType: string) => void;
  fetchOwners: (data: any) => void;
  user: any;
  urlName: string;
  dialogCloseHandler?: () => void;
  setActiveTab: (tab: Tabs) => void;
  owners: Client[];
  showLoader: any;
  hideLoader: any;
}
interface ContentRequestCreateState {
  requestData: ContentRequest;
  isRequestForMyOrg: boolean;
  loading: boolean;
  areAllSectionsValid: boolean;
  completionPercent: number;
  isNotSavedYet: boolean;
  showPopupDialog: boolean;
  canChangeRequestForMyOrg: boolean;
  hasWorkStarted: boolean;
}

class ContentRequestCreateContainer extends Component<
  ContentRequestCreateProps,
  ContentRequestCreateState
> {
  isMultiCenterHead: boolean;
  isCenterHead: boolean;
  requestContentType: RequestContentType;
  requestId: string;
  existingUserIds: Set<string>;

  constructor(props: ContentRequestCreateProps) {
    super(props);
    this.requestContentType = props.match.params.requestContentType;
    this.isMultiCenterHead = isLoggedInUserMultiCenterHead();
    this.isCenterHead = isLoggedInUserCenterHead();

    this.requestId = props.match.params.requestId;
    this.state = {
      requestData: generateDefaultContentRequest(this.requestContentType),
      isRequestForMyOrg: this.isCenterHead ? true : false,
      canChangeRequestForMyOrg: true,
      loading: true,
      areAllSectionsValid: false,
      isNotSavedYet: false,
      showPopupDialog: false,
      hasWorkStarted: false, // Represents whether work has started on this request for any subject,
      completionPercent: 0,
    };
    this.existingUserIds = new Set(); // Used for determining users for which isEmailTriggered will be sent as true
  }

  componentDidMount() {
    if (this.requestContentType === RequestContentType.TEST) {
      this.props.getContentSubType("testpapers");
    } else {
      this.props.getContentSubType("question");
    }
    this.fetchData();
  }
  fetchData = async () => {
    try {
      await this.fetchRequestData();
      const res = await contentRequestServices.getOwners();
      console.log("owners", res.responseObject);
      this.props.fetchOwners(res.responseObject);
      this.handleCanChangeChangeMyOrg(res.responseObject.owners);
    } catch (err) {
      console.log("Error in container", err);
    }
  };
  handleCanChangeChangeMyOrg = (owners: any) => {
    const { user } = this.props;
    if (owners && owners.length === 1 && user) {
      // If only one owner and the clientId is same as logged in user's client id
      // then request is for my org and cant be changed
      const { id: clientId } = owners[0];
      if (clientId === user.clientId._id) {
        this.setState({
          isRequestForMyOrg: true,
          canChangeRequestForMyOrg: false,
        });
      }
    }
  };

  componentDidUpdate(prevProps: ContentRequestCreateProps) {
    const { owners, user } = this.props;
    if (
      prevProps.owners.length === 0 &&
      owners &&
      owners.length === 1 &&
      user
    ) {
      this.handleCanChangeChangeMyOrg(owners);
    }
  }

  hasAnyContentOwnerStartedWork = (requestData: ContentRequest) => {
    const subjects: Subject[] = _.get(
      requestData,
      "requestInfo.details.subjects",
      []
    );
    for (let subject of subjects) {
      const { questions } = subject;
      const workStarted = hasWorkStartedForASubject(questions);
      if (workStarted) {
        return workStarted;
      }
    }
    return false;
  };

  fetchRequestData = async () => {
    try {
      const response = await contentRequestServices.getRequestProgress(
        this.requestId,
        this.isMultiCenterHead,
        true
      );
      const { user } = this.props;

      const userClientId = _.get(user, "clientId._id", "");

      const { owners } = response.contentRequestDetails.requestInfo;
      let isRequestForMyOrg =
        !owners || (owners.length === 0 && this.isMultiCenterHead)
          ? false
          : true;
      for (let owner of owners) {
        const ownerClientId = _.get(owner, "client.id", "");
        if (userClientId && ownerClientId && userClientId !== ownerClientId) {
          isRequestForMyOrg = false;
          break;
        }
      }
      console.log("In fetchRequestData", isRequestForMyOrg);
      const requestData = response.contentRequestDetails;
      this.existingUserIds = extractUserIdsFromRequest(requestData);
      
      this.setState({
        requestData,
        isRequestForMyOrg,
        hasWorkStarted:
          this.hasAnyContentOwnerStartedWork(requestData) ||
          hasTestOwnerStartedWork(requestData),
      });
    } catch (error) {
      console.log(error);
    }
    this.setState({
      loading: false,
    });
  };

  toggleRequestForMyOrg = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        isRequestForMyOrg: !prevState.isRequestForMyOrg,
      };
    });
  };

  renderHeaderTitle = () => {
    const {
      requestData: { requestId: requestContentId },
    } = this.state;

    return `${requestContentId || ""} | Content Request - Create ${_.capitalize(
      this.requestContentType
    )}`;
  };

  handleOrderNotes = ({ orderNotes, orderNoteAttachments }: any) => {
    this.setState((prevState) => {
      const newRequestData = { ...prevState.requestData };
      const newRequestInfo = { ...newRequestData.requestInfo };
      newRequestInfo.orderNote = orderNotes;
      newRequestInfo.orderNoteAttachments = orderNoteAttachments;
      newRequestData.requestInfo = newRequestInfo;

      return {
        ...prevState,
        requestData: newRequestData,
        isNotSavedYet: true,
      };
    });
  };

  handleRequestDataChange = (requestData: ContentRequest) => {
    this.setState({
      requestData,
      isNotSavedYet: true,
    });
  };

  onJobDone = async () => {
    const { user, showLoader, hideLoader } = this.props;
    try {
      const { completionPercent } = this.state;
      showLoader();
      const preSaveModifiedRequestData = await preSaveRequestModifications({
        ...this.state.requestData,
        completionPercent,
      });
      hideLoader();
      const finalRequestPayload = prePublishRequestModifications(
        preSaveModifiedRequestData,
        user,
        { isRequestForMyOrg: this.state.isRequestForMyOrg, existingUserIds: this.existingUserIds }
      );
      await contentRequestServices.updateContentRequest(finalRequestPayload);
      this.props.history.push("/contentRequest");
      this.props.setActiveTab(Tabs.SentRequest);
    } catch (error) {
      hideLoader();
      console.log(error);
    }
  };

  onSave = async () => {
    const { showLoader, hideLoader } = this.props;
    try {
      const { requestData, completionPercent } = this.state;
      showLoader();
      const preSaveModifiedRequestData = await preSaveRequestModifications({
        ...requestData,
        completionPercent,
      });
      hideLoader();

      await contentRequestServices.updateContentRequest(
        preSaveModifiedRequestData
      );
      this.setState({
        isNotSavedYet: false,
        showPopupDialog: false,
      });
    } catch (error) {
      console.log(error);
      hideLoader();
    }
  };

  onSectionsValidtyChange = (
    areAllSectionsValid: boolean,
    completionPercent: number
  ) => {
    this.setState({
      areAllSectionsValid,
      completionPercent,
    });
  };
  handleCancelOnPopup = () => {
    //   const {
    //     requestData: { _id },
    //   } = this.state;
    //  contentRequestServices.deleteContentRequest(_id||'');
    //   this.setState({
    //     showPopupDialog:false
    //   })
    const { history } = this.props;
    history.push("/contentRequest");
  };
  onclosePopup = () => {
    if (this.state.isNotSavedYet) {
      this.setState({
        showPopupDialog: true,
      });
    } else {
      const { history } = this.props;
      history.push("/contentRequest");
    }
  };
  handleSaveOrDiscardPopupClose = () => {
    this.setState({
      showPopupDialog: false,
    });
  };
  render() {
    const {
      classes,
      contentsubType,
      match: {
        params: { requestContentType = RequestContentType.TEST },
      },
    } = this.props;
    const {
      requestData,
      isRequestForMyOrg,
      loading,
      areAllSectionsValid,
      showPopupDialog,
      canChangeRequestForMyOrg,
      hasWorkStarted,
    } = this.state;

    if (loading) {
      return null;
    }

    return (
      <>
      <Grid className={classes.DialogContainer}>
        <DialogLarge
          headerTitle={
            <>
            <img src="/assets/svg/cr-icon.svg" />
            <span>{this.renderHeaderTitle()}</span>
            </>
          }
          showTopNavContent={false}
          isFooter
          isShowHeader={true}
          isEditHidden
          isJobDoneDisabled={!areAllSectionsValid}
          onJobDone={this.onJobDone}
          onSave={this.onSave}
          dialogCloseHandler={this.onclosePopup}
          footerCTAName="Assign task"
          headerCTAName="Save"
        >
          <Grid container spacing={24} className={classes.marginTop20}>
            <Grid item xs={2}>
              <Grid>
                <SectionInContent
                  showDraftPercentage
                  onSectionsValidtyChange={this.onSectionsValidtyChange}
                  key={isRequestForMyOrg ? 4 : 3} // change key to re-render section in content when children are dynamically changed
                >
                  <SectionInContentItem
                    value={requestData}
                    validate={(value: ContentRequest) =>
                      validateBasicDetails(value, this.requestContentType)
                    }
                    sectionId={_.camelCase(
                      `${_.capitalize(this.requestContentType)} Details`
                    )}
                  >
                    {_.capitalize(this.requestContentType)} Details
                  </SectionInContentItem>
                  <SectionInContentItem
                    value={requestData}
                    validate={validateRequestDetails}
                    sectionId="requestDetails"
                  >
                    Task Details
                  </SectionInContentItem>
                  <SectionInContentItem
                    value={requestData.requestInfo.orderNote}
                    validate={validateOrderNotes}
                    sectionId="addOrderNotes"
                  >
                    Add Order Notes
                  </SectionInContentItem>
                  {isRequestForMyOrg && (
                    <SectionInContentItem
                      value={requestData}
                      validate={validateSelectContentOwners}
                      sectionId="selectContentOwners"
                    >
                      Select Content Owners
                    </SectionInContentItem>
                  )}
                </SectionInContent>
              </Grid>
            </Grid>
            <Grid item xs={8}>
              {/* {this.isMultiCenterHead && (
                <Grid
                  container
                  justify="space-between"
                  alignItems="center"
                  className={classes.switchGrid}
                >
                  <Grid item>
                    <Typography className={classes.panelHeading}>
                      This Content Request is for my Organization
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Switch
                      color="primary"
                      disableRipple
                      checked={isRequestForMyOrg}
                      classes={{
                        root: classes.swithMain,
                        icon: classes.switchIcon,
                        bar: classes.switchBar,
                        iconChecked: classes.IscheckedSwitch,
                        checked: classes.checkedSwitch,
                      }}
                      disabled={!canChangeRequestForMyOrg || hasWorkStarted}
                      onChange={this.toggleRequestForMyOrg}
                    />
                  </Grid>
                </Grid>
              )} */}
              {this.requestContentType === RequestContentType.QUESTION ? (
                <AddQuestionDetail
                  transferToParent={this.handleRequestDataChange}
                  requestData={requestData}
                  isSectionDisabled={hasWorkStarted}
                />
              ) : (
                <AddTestDetail
                  contentsubType={contentsubType}
                  transferToParent={this.handleRequestDataChange}
                  requestData={requestData}
                  isSectionDisabled={hasWorkStarted}
                />
              )}

              <AddRequestDetail
                transferToParent={this.handleRequestDataChange}
                requestData={requestData}
                requestContentType={requestContentType}
                isRequestForMyOrg={isRequestForMyOrg}
                isSectionDisabled={hasWorkStarted}
              />
              <MyPATBaseSection sectionId="addOrderNotes">
                <div>
                  <SectionFocusedContext.Consumer>
                    {({ setSectionFocus }: SectionFocusedContextValue) => (
                      <AddOrderNotes
                        transferToParent={this.handleOrderNotes}
                        orderNotes={requestData.requestInfo.orderNote || ""}
                        orderNoteAttachments={
                          requestData.requestInfo.orderNoteAttachments
                        }
                        isSectionDisabled={hasWorkStarted}
                        setSectionFocus={setSectionFocus}
                      />
                    )}
                  </SectionFocusedContext.Consumer>
                </div>
              </MyPATBaseSection>
              {isRequestForMyOrg && (
                <SelectContentOwners
                  contentsubType={contentsubType}
                  requestData={requestData}
                  requestContentType={requestContentType}
                  transferToParent={this.handleRequestDataChange}
                />
              )}
            </Grid>
            <Grid item xs={2}>
              <MyPATCollapseSection>
                <MyPATCollapseSectionItem
                  sectionKey="requestInfo"
                  sectionName="Request Info"
                  icon="/assets/svg/new-info.svg"
                >
                  <RequestInfo requestData={requestData} />
                </MyPATCollapseSectionItem>
              </MyPATCollapseSection>
            </Grid>
          </Grid>
        </DialogLarge>
        {/* @frontend Add Test Owners &amp; specify their deadlines */}
        <MyPATDialog
          dialogOpen={false}
          dialogHasActions={true}
          isOverflowVisible={true}
          dialogHeading={
            <>
              <Grid container justify="flex-start">
                <Typography className={classes.mainHeading}>
                  Add Test Owners &amp; specify their deadlines
                </Typography>
                <Typography className={classes.subHeading}>
                  Select authors responsible for creating, evaluating,
                  moderating, publishing test, along with deadlines
                </Typography>
              </Grid>
            </>
          }
          isAlignCenter={false}
          isCustomBackground={false}
          isborderDialogAction={false}
          otherDialogProps={{
            fullWidth: true,
            maxWidth: "md",
            scroll: "body",
          }}
          customDialogActions={
            <>
              <Grid
                container
                justify="flex-end"
                spacing={8}
                alignItems="center"
                // className={classes.dialogActions}
              >
                <Grid item>
                  <Button color="primary">Reset</Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" color="primary">
                    Done
                  </Button>
                </Grid>
              </Grid>
            </>
          }
        >
          <Grid container justify="flex-start" spacing={24}>
            <Grid item xs={6}>
              <Typography className={classes.inputLable}>
                Add Test Creator
                <CustomInfoIcon
                  infoDialogContentType="Add Test Creator"
                  isCenterArrow={true}
                  isRightArrow={false}
                  isInfoIcon={true}
                  knowMoreAbout={false}
                  dialogTitle="Add Test Creator"
                  imageURL="/assets/svg/infoIcon/createQuestion/math.svg"
                  dialogPara="What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text "
                  details="Click to know more"
                  toolTipDirection="top"
                />
              </Typography>
              <MyPATTextField
                placeholder="Search Test Creator and add"
                fullWidthControl
              />
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.inputLable}>Add Date</Typography>
              <MyPATTextField
                placeholder="Search Test Creator and add"
                fullWidthControl
              />
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.inputLable}>
                Add Test Evaluator
                <CustomInfoIcon
                  infoDialogContentType="Add Test Evaluator"
                  isCenterArrow={true}
                  isRightArrow={false}
                  isInfoIcon={true}
                  knowMoreAbout={false}
                  dialogTitle="Add Test Evaluator"
                  imageURL="/assets/svg/infoIcon/createQuestion/math.svg"
                  dialogPara="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
                  details="Click to know more"
                  toolTipDirection="top"
                />
              </Typography>
              <MyPATTextField
                placeholder="Search Test Evaluator and add"
                fullWidthControl
              />
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.inputLable}>Add Date</Typography>
              <MyPATTextField
                placeholder="Search Test Creator and add"
                fullWidthControl
              />
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.inputLable}>
                Add Test Lang. Evaluator
                <CustomInfoIcon
                  infoDialogContentType="Add Test Lang. Evaluator"
                  isCenterArrow={true}
                  isRightArrow={false}
                  isInfoIcon={true}
                  knowMoreAbout={false}
                  dialogTitle="Add Test Lang. Evaluator"
                  imageURL="/assets/svg/infoIcon/createQuestion/math.svg"
                  dialogPara="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
                  details="Click to know more"
                  toolTipDirection="top"
                />
              </Typography>
              <MyPATTextField
                placeholder="Search Test Lang. Evaluator and add"
                fullWidthControl
              />
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.inputLable}>Add Date</Typography>
              <MyPATTextField
                placeholder="Search Test Creator and add"
                fullWidthControl
              />
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.inputLable}>
                Add Test Moderator
                <CustomInfoIcon
                  infoDialogContentType="Add Test Moderator"
                  isCenterArrow={true}
                  isRightArrow={false}
                  isInfoIcon={true}
                  knowMoreAbout={false}
                  dialogTitle="Add Test Moderator"
                  imageURL="/assets/svg/infoIcon/createQuestion/math.svg"
                  dialogPara="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
                  details="Click to know more"
                  toolTipDirection="top"
                />
              </Typography>
              <MyPATTextField
                placeholder="Search Test Moderator and add"
                fullWidthControl
              />
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.inputLable}>Add Date</Typography>
              <MyPATTextField
                placeholder="Search Test Creator and add"
                fullWidthControl
              />
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.inputLable}>
                Add Test Publisher
                <CustomInfoIcon
                  infoDialogContentType="Add Test Publisher"
                  isCenterArrow={true}
                  isRightArrow={false}
                  isInfoIcon={true}
                  knowMoreAbout={false}
                  dialogTitle="Add Test Publisher"
                  imageURL="/assets/svg/infoIcon/createQuestion/math.svg"
                  dialogPara="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
                  details="Click to know more"
                  toolTipDirection="top"
                />
              </Typography>
              <MyPATTextField
                placeholder="Search Test Publisher and add"
                fullWidthControl
              />
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.inputLable}>Add Date</Typography>
              <MyPATTextField
                placeholder="Search Test Creator and add"
                fullWidthControl
              />
            </Grid>
          </Grid>
        </MyPATDialog>

        <MyPATDialog
          dialogOpen={showPopupDialog}
          dialogHasActions={true}
          dialogHeading="Save then proceed"
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={this.handleSaveOrDiscardPopupClose}
          isCustomBackground={false}
          otherDialogProps={{
            fullWidth: false,
            maxWidth: false,
          }}
        >
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
            className={classes.saveDialogContainer}
          >
            <Grid item>
              <img src="/assets/svg/contentRequest/saving.svg" alt="saving" />
            </Grid>
            <Grid item className="paraDetails">
              <Typography align="center">
                You need to save the content before canceling the request. This
                will help you to retain your data
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={this.handleCancelOnPopup}
                >
                  Discard changes
                </Button>
                &nbsp;&nbsp;
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onSave}
                >
                  Save & Proceed
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </MyPATDialog>
      </Grid>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  contentsubType: _.get(state, "testTemplate.contentSubType.list", {}),
  user: state.loginData.userData.authenticatedUser,
  owners: state.contentRequestReducer.contentRequestCreateReducer.owners,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getContentSubType,
      fetchOwners: contentRequestCreateActions.fetchOwners,
      setActiveTab,
      showLoader: () => dispatch({ type: "SHOW_LOADER" }),
      hideLoader: () => dispatch({ type: "HIDE_LOADER" }),
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(ContentRequestCreateContainer));
